import classNames from "classnames";
import classes from "./SuccessorNotification.module.less";
import {CardTag} from "~/ProductDetails/components/PhaseInOut/CardTag/CardTag";
import {getProductData, type ProductData} from "~/models/ProductData";
import {IMG_SUCCESSOR_ARROW, IMG_SUCCESSOR_BOX} from "~/utils/url/staticResources";
import {SlicedImage} from "~/ProductDetails/components/PhaseInOut/SlicedImage/SlicedImage";
import {getPrimaryImage} from "~/utils/product/getPrimaryImage";
import {ImageFormat} from "~/dto/ProductDataDTO";
import {Trans, useTranslation} from "react-i18next";
import type {ProductDescriptor} from "~/feature/ProductDescriptor/v1/types";

interface Props {
  variant?: "basic" | "extended";
  className?: string;
  successor: ProductData | ProductDescriptor;
  discontinued?: ProductData | ProductDescriptor;
}

export const SuccessorNotification = (props: Props) => {
  const { t } = useTranslation();
  const successor = getProductData(props.successor);
  let discontinued: ProductData | null = null;
  const { variant = "basic" } = props;
  if (variant === "extended") {
    discontinued = getProductData(props.discontinued!);
  }
  const tagLabel = t(`page.pdp.phaseinout.successor.tag.${variant}`);
  return (
    <a
      tracking-aux-aspr-type={"New"}
      tracking-aux-aspr-name={successor.designation}
      tracking-aux-aspr-id={successor.code}
      href={successor.url}
      className={classNames(classes.root, props.className)}
    >
      <CardTag className={classes.tag}>{tagLabel}</CardTag>
      <div className={classes.content}>
        <div className={classes.imageSection}>
          {variant === "extended" && (
            <SlicedImage
              className={classes.productImage}
              src={getPrimaryImage(successor.images, { imageFormat: ImageFormat.product })?.url ?? ""}
              gapSize={2}
            />
          )}
          {variant === "extended" && <img className={classes.arrowImage} src={IMG_SUCCESSOR_ARROW} alt={""} />}
          <img className={classes.boxImage} src={IMG_SUCCESSOR_BOX} alt={""} />
        </div>
        <div className={classes.text}>
          {variant === "extended" && (
            <p className={classes.shoutout}>
              <Trans i18nKey={"page.pdp.phaseinout.successor.shoutout"}>
                The production of {{ designation: discontinued!.designation }} will be <b>discontinued soon.</b>
              </Trans>
            </p>
          )}

          <p className={classNames(classes.headline, classes.headlineBig)}>
            <Trans i18nKey={"page.pdp.phaseinout.successor.headline"}>
              New version {{ designation: successor.designation }} is now available!
            </Trans>
          </p>
          <p className={classes.description}>
            <Trans i18nKey={"page.pdp.phaseinout.successor.description"}>
              We invite you to switch to the newer version of this product:{" "}
              <span className={classes.pseudoLink}>{{ designation: successor.designation }}</span>, which you can buy
              now.
            </Trans>
          </p>
        </div>
      </div>
    </a>
  );
};
